// Importing necessary React components and custom modules
import React from "react";
import Banner from "../../components/banner/Banner";
import "./Brands.css";
import CategoryProducts from "../../components/CategoryProducts/CategoryProducts";
import Title from "../../components/titles/Title";
import BrandsCategory from "./BrandsCategory";
import BrandsCerification from "./BrandsCerification";
import BrandsBenefits from "./BrandsBenefits";
import ManufacturingOnDemand from "./ManufacturingOnDemand";

// Importing icons used for the technology section
import DSN from "../../assets/images/technology-icons/dsn.svg";
import PPN from "../../assets/images/technology-icons/ppn.svg";
import MP from "../../assets/images/technology-icons/marketplace.svg";

// Brands component
const Brands = () => {
  return (
    <>
      {/* Top banner section */}
      <Banner
        className="home-bg"
        bannerTitle={[
          "Access Contract Manufacturing Services to build your  ",
          <br className="d-lg-block d-none"></br>,
          " brand with Organic and Traceable honey",
        ]}
      />

      {/* Category products section for Contract Manufacturing Services */}
      <CategoryProducts
        btn1text="RFQ"
        categoryId={["AGR15-100C"]}
        title="Contract Manufacturing Services"
        description="Services not found"
        subcategory="true"
        price="false"
      />

      {/* Section for Manufacturing on Demand */}
      <div className="container">
        <Title classname="text-center mb-5" heading="Our Services" />
        <ManufacturingOnDemand />
      </div>

      {/* Section for displaying product-related services */}
      <div className="container">
        <Title classname="text-center mb-5" heading="Our Product Services" />
        <BrandsCategory />
      </div>

      {/* Section for certifications and licenses */}
      <div className="container section-container">
        <Title classname="text-center mb-5" heading="Certifications & Licenses" />
        <BrandsCerification />
      </div>

      {/* Section highlighting benefits */}
      <div className="container">
        <Title classname="text-center mb-5" heading="Benefits" />
        <BrandsBenefits sliceValue="0" />
      </div>

      {/* Technology section: DSN, PPN, and Marketplace */}
      <div className="section-container benefit-container">
        <div className="container">
          <div className="section-sub-container text-center">
            <Title heading="Our Technology" />

            {/* DSN Technology */}
            <img className="technoloy-icons d-block mb-2 mx-auto mt-4" src={DSN} alt="Dark Store Network" />
            <h5 className="mb-3">Dark Store Network (DSN)</h5>
            <p>
              Dark Store Network (DSN) is an innovative technology solution provided by Apischain to enable brands to efficiently store and manage their products in strategically located stores. Unlike traditional retail spaces, dark stores are dedicated facilities optimized for order fulfillment rather than customer browsing. DSN offers brands a seamless way to store products in these stores, allowing for faster delivery and more efficient inventory management. Through real-time tracking, inventory optimization, and advanced data insights, DSN helps brands reduce operational costs, improve supply chain efficiency, and enhance the overall customer experience with faster and more reliable order fulfillment.
            </p>
            <p>Agent, Agriminer, Store Owner, Store Operator, Store QA, Driver</p>

            {/* PPN Technology */}
            <img className="technoloy-icons d-block mb-2 mx-auto mt-4" src={PPN} alt="Plant Production Network" />
            <h5 className="mb-3">The Plant Production Network (PPN)</h5>
            <p>
              The Plant Production Network (PPN) is a technology platform developed by Apischain to support brands in optimizing their plant production processes. By leveraging advanced digital solutions, PPN enhances efficiency, enables real-time data tracking, and improves overall production management. This network helps brands streamline their operations, reduce costs, and ensure higher productivity by providing seamless integration between different stages of production and supply chains.
            </p>
            <p>Agent, AgriMiner, Plant Owner, Plant Operator, Plant QA, Plant Manager, Plant Technician, Worker, Plant Executive, Processing Worker, Packaging Worker</p>

            {/* Marketplace Technology */}
            <img className="technoloy-icons d-block mb-2 mx-auto mt-4" src={MP} alt="Market-Place" />
            <h5 className="mb-3">Marketplace</h5>
            <p>
              Marketplace is a technology platform developed by Apischain that facilitates the buying and selling of products. It connects buyers and sellers in a seamless digital environment, enabling efficient transactions and access to a wide range of goods
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Brands;
